import { ref, unref } from "vue"
import XEUtils from "xe-utils"

export interface ScrollToParams {
	el: any
	to: number
	duration?: number
	callback?: () => any
}

const easeInOutQuad = (t: number, b: number, c: number, d: number) => {
	t /= d / 2
	if (t < 1) {
		return (c / 2) * t * t + b
	}
	t--
	return (-c / 2) * (t * (t - 2) - 1) + b
}
const move = (el: HTMLElement, amount: number) => {
	el.scrollTop = amount
}

const position = (el: HTMLElement) => {
	return el.scrollTop
}

/**
 * 动画滚动
 * @param el 目标元素
 * @param to 目标位置
 * @param duration 持续时间
 * @param callback 回调函数
 */
export function useScrollTo({ el, to, duration = 500, callback }: ScrollToParams) {
	// 是否激活的引用
	const isActiveRef = ref(false)
	// 当前位置
	const start = position(el)
	// 需要移动的距离
	const change = to - start
	// 每次增量
	const increment = 20
	// 当前时间
	let currentTime = 0
	// 设置默认持续时间
	duration = XEUtils.isUndefined(duration) ? 500 : duration

	// 动画滚动函数
	const animateScroll = function () {
		// 如果引用为 falsy 值，则返回
		if (!unref(isActiveRef)) {
			return
		}
		// 增加当前时间
		currentTime += increment
		// 计算当前位置的值
		const val = easeInOutQuad(currentTime, start, change, duration)
		// 移动元素到指定位置
		move(el, val)
		// 如果当前时间小于持续时间且引用为真，则继续动画滚动
		if (currentTime < duration && unref(isActiveRef)) {
			requestAnimationFrame(animateScroll)
		} else {
			// 如果存在回调函数，则执行回调函数
			if (callback && XEUtils.isFunction(callback)) {
				callback()
			}
		}
	}
	// 运行函数
	const run = () => {
		// 将引用设为 true
		isActiveRef.value = true
		// 开始动画滚动
		animateScroll()
	}

	// 停止函数
	const stop = () => {
		// 将引用设为 false
		isActiveRef.value = false
	}

	// 返回起停函数对象
	return { start: run, stop }
}
